<!-- Compiled at 2026-05-13T13:50:05.286Z -->
<ng-container *ngIf="$isVariablesInitialized()">
	<ng-container *lowgileScope="null; screen: this; let $scope">
		<ng-container *lowgileForm="null; screen: this; let $formDirective">
			<div style="display: contents" [class.fill]="false">
				<Llama-MainLayout
					[$formDirective]="$formDirective"
					[$disabled]="$disabled"
					[$ignoreValidations]="$ignoreValidations"
					[screenTitle]="'Invoice Preparation'"
					[isForExternalUser]=""
				>
					<ng-template
						data-content-area="content"
						let-$scope="$scope"
						let-$formDirective="$formDirective"
						let-$disabled="$disabled"
					>
						<div data-content-area="content" data-defined-in="Llama.InvoicePreparation">
							<div
								class="layout-block"
								style="padding: 1rem; justify-content: space-between"
								[style.align-items]="'inherit'"
								[class.horizontal]="Sys.Layout.sizeIsGreaterThanOrEqual.XSmall"
								[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
								[style.gap]="'1em'"
							>
								<div
									class="layout-block"
									[style.align-items]="'inherit'"
									[class.horizontal]="Sys.Layout.sizeIsGreaterThanOrEqual.XSmall"
									[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
									[style.gap]="'1em'"
								>
									<mat-card>
										<mat-card-content>
											<h5
												style="margin-top: 0"
												[innerHtml]="'Total count ' | escapeHtml: 'none' | replaceNewlines: 'h5'"
											></h5>
											<h1
												[innerHtml]="screen.stats.totalCount || '--' | escapeHtml: 'none' | replaceNewlines: 'h1'"
											></h1>
										</mat-card-content>
									</mat-card>
									<mat-card>
										<mat-card-content>
											<h5
												style="margin-top: 0"
												[innerHtml]="'Total tip' | escapeHtml: 'none' | replaceNewlines: 'h5'"
											></h5>
											<h1
												[innerHtml]="screen.stats.totalTip || '--' | escapeHtml: 'none' | replaceNewlines: 'h1'"
											></h1>
										</mat-card-content>
									</mat-card>
									<mat-card>
										<mat-card-content>
											<h5
												style="margin-top: 0"
												[innerHtml]="'Total VAT' | escapeHtml: 'none' | replaceNewlines: 'h5'"
											></h5>
											<h1
												[innerHtml]="screen.stats.totalVat || '--' | escapeHtml: 'none' | replaceNewlines: 'h1'"
											></h1>
										</mat-card-content>
									</mat-card>
									<mat-card>
										<mat-card-content>
											<h5
												style="margin-top: 0"
												[innerHtml]="'Total' | escapeHtml: 'none' | replaceNewlines: 'h5'"
											></h5>
											<h1
												[innerHtml]="screen.stats.totalAmount || '--' | escapeHtml: 'none' | replaceNewlines: 'h1'"
											></h1>
										</mat-card-content>
									</mat-card>
								</div>
								<ng-container
									*ngIf="screen.filterProjectId && screen.expenses.length"
									><div
										class="layout-block vertical"
										style="padding: 0 1.5em"
										[style.align-items]="'inherit'"
										[style.gap]="'1em'"
									>
										<mat-card>
											<mat-card-header>
												<mat-card-title
													><span
														[innerHtml]="'Assing to invoice' | escapeHtml: 'none' | replaceNewlines: 'span'"
													></span
												></mat-card-title>
											</mat-card-header>

											<mat-card-content>
												<mat-form-field
													appearance="outline"
													style="margin-top: 1em"
												>
													@let $fc_47_1 = getFormControl(screen,
													'invoiceId', 47, $scope, $formDirective,
													$disabled, $ignoreValidations);
													<mat-label
														[innerHtml]="'Invoice ID' | escapeHtml"
													></mat-label>
													<input
														#input_47
														[formControl]="$fc_47_1"
														type="text"
														matInput
													/>

													@for(error of $fc_47_1.errors ?? {} | keyvalue;
													track error.key) {
													<mat-error
														*ngIf="typeof error.value == 'string'"
														[innerHtml]="error.value | escapeHtml: 'safe'"
													/>
													}
												</mat-form-field>

												<button
													mat-raised-button
													class="has-click-handler"
													color="basic"
													style="margin-left: 1.5em"
													(click)="handler_ButtonBlock_48_click_assignToInvoice_0($event, {  })"
													[disabled]="$disabled"
												>
													<mat-icon>{{'checklist'}}</mat-icon
													><span
														[innerHtml]="'Assign' | escapeHtml: 'none' | replaceNewlines: 'span'"
													></span>
												</button>
											</mat-card-content>
										</mat-card></div
								></ng-container>
							</div>
							<div
								class="layout-block vertical"
								style="padding: 1rem"
								[style.align-items]="'inherit'"
								[style.gap]="'1em'"
							>
								<mat-card>
									<mat-card-content>
										<div style="display: inline-block">
											<mat-form-field
												class="has-dateChange-handler"
												appearance="outline"
												(dateChange)="handler_DatePickerBlock_14_dateChange_loadExpenses_0($event, {  })"
												class="fill"
											>
												@let $fc_14_1 = getFormControl(screen, 'filterDate',
												14, $scope, $formDirective, $disabled,
												$ignoreValidations);
												<mat-label
													[innerHtml]="'Include expenses until' | escapeHtml"
												></mat-label>
												<input
													class="has-dateChange-handler"
													(dateChange)="handler_DatePickerBlock_14_dateChange_loadExpenses_0($event, {  })"
													matInput
													[formControl]="$fc_14_1"
													[matDatepicker]="picker171837"
												/>
												<mat-datepicker-toggle
													matSuffix
													[for]="picker171837"
												></mat-datepicker-toggle>
												<mat-datepicker #picker171837></mat-datepicker>
												@for(error of $fc_14_1.errors ?? {} | keyvalue;
												track error.key) {
												<mat-error
													*ngIf="typeof error.value == 'string'"
													[innerHtml]="error.value | escapeHtml: 'safe'"
												/>
												}
											</mat-form-field>
										</div>
										<mat-form-field
											class="has-selectionChange-handler"
											appearance="outline"
											style="width: 480px; margin-left: 1.5em"
											(selectionChange)="handler_DropdownBlock_13_selectionChange_loadExpenses_0($event, {  })"
										>
											@let $fc_13_1 = getFormControl(screen,
											'filterProjectId', 13, $scope, $formDirective,
											$disabled, $ignoreValidations);

											<mat-label
												[innerHtml]="'Projects' | escapeHtml"
											></mat-label>
											<mat-select
												class="has-selectionChange-handler"
												(selectionChange)="handler_DropdownBlock_13_selectionChange_loadExpenses_0($event, {  })"
												[formControl]="$fc_13_1"
												[compareWith]="$compare"
												#select_13="matSelect"
												[lgFormComponent]="select_13"
												[lgFormValue]="screen.filterProjectId"
												canSelectNullableOptions
											>
												@let emptyOption_13 = null; @if (emptyOption_13) {
												<mat-option [value]="emptyOption_13[0]"
													>{{ emptyOption_13[1] }}</mat-option
												>
												}

												<mat-option
													*ngFor="let $option of (screen.projectsOptions); let $index = index"
													[value]="$option.id"
												>
													<span
														[innerHtml]="$option.name | escapeHtml"
														style="margin: auto 0"
													></span>
												</mat-option>
											</mat-select>

											@for(error of $fc_13_1.errors ?? {} | keyvalue; track
											error.key) {
											<mat-error
												*ngIf="typeof error.value == 'string'"
												[innerHtml]="error.value | escapeHtml: 'safe'"
											/>
											}
										</mat-form-field>
										<mat-form-field
											*ngIf="$any(screen.filterProjectId)?.$isOther"
										>
											@let $fc_13_3 = getFormControl(screen.filterProjectId,
											'$otherValue', 13, $scope, $formDirective, $disabled,
											$ignoreValidations);
											<mat-label
												[innerHtml]="'Projects' + ' (Other)' | escapeHtml"
											></mat-label>
											<input type="text" matInput [formControl]="$fc_13_3" />
										</mat-form-field>

										<ng-container *ngIf="!screen.filterProjectId"
											><div
												class="layout-block vertical"
												style="margin-top: 3em"
												[style.align-items]="'center'"
												[style.gap]="'1em'"
											>
												<mat-icon
													[innerHtml]="'filter_list'"
													fontSet="material-icons"
													[inline]="false"
												></mat-icon>
												<h3
													[innerHtml]="'Select the project to list chargeable expenses' | escapeHtml: 'none' | replaceNewlines: 'h3'"
												></h3></div
										></ng-container>

										<ng-container *ngIf="screen.filterProjectId"
											><lowgile-table
												#datatable_7
												[dataSignal]="_DataTableBlock_collectionCodeSignal_7(datatable_7, { app, screen, $pathSegments, $disabled })"
												[trackBy]="trackByAutomatic"
												[entity]="This.Expense"
												[columns]="_DataTableBlock_columns_7(screen)"
												[showSettings]="true"
												[userDefinedConfiguration]="undefined"
												[usePaging]="true"
												[pageSize]="20"
												[pageSizeOptions]="[10, 20, 50]"
												[useGlobalFilter]="false"
												[debouncingDelay]="250"
												[stickyHeader]="true"
												[additionalFindOptions]="_DataTableBlock_additionalFindOptions_7({ app, screen, $pathSegments, $disabled })"
												[additionalHeaderRows]="[]"
												[additionalFooterRows]="[]"
												[allClasses]="$Modules"
												[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
												[surroundingScope]="$scope"
												#$table_7="lowgileTable"
											>
												<ng-container [lowgile-column]="'expenseDate'">
													<th mat-header-cell *matHeaderCellDef>
														<span
															[innerHtml]="'Expense Date' | escapeHtml: 'none' | replaceNewlines: 'span'"
														></span>
													</th>
													<td
														mat-cell
														*matCellDef="let item; let index = index"
														[attr.data-label]="'Expense Date'"
													>
														<ng-container
															*lowgileScope="item; as: 'item'; let $scope"
														>
															<ng-container
																*lowgileScope="index; as: 'index'; let $scope"
															>
																<span
																	[innerHtml]="_DataTableColumnBlock_cellText_8({ app, screen, $pathSegments, $disabled, item, index }) | escapeHtml: 'none' | replaceNewlines: 'span'"
																></span>
															</ng-container>
														</ng-container>
													</td>
												</ng-container>
												<ng-container
													[lowgile-column]="('expenseDate') + '$$filter'"
												>
													<th mat-header-cell *matHeaderCellDef></th>
												</ng-container>

												<ng-container [lowgile-column]="'name'">
													<th mat-header-cell *matHeaderCellDef>
														<span
															[innerHtml]="'Name' | escapeHtml: 'none' | replaceNewlines: 'span'"
														></span>
													</th>
													<td
														mat-cell
														*matCellDef="let item; let index = index"
														[attr.data-label]="'Name'"
													>
														<ng-container
															*lowgileScope="item; as: 'item'; let $scope"
														>
															<ng-container
																*lowgileScope="index; as: 'index'; let $scope"
															>
																<span
																	[innerHtml]="_DataTableColumnBlock_cellText_9({ app, screen, $pathSegments, $disabled, item, index }) | escapeHtml: 'none' | replaceNewlines: 'span'"
																></span>
															</ng-container>
														</ng-container>
													</td>
												</ng-container>
												<ng-container
													[lowgile-column]="('name') + '$$filter'"
												>
													<th mat-header-cell *matHeaderCellDef></th>
												</ng-container>

												<ng-container [lowgile-column]="'employee'">
													<th mat-header-cell *matHeaderCellDef>
														<span
															[innerHtml]="'Employee' | escapeHtml: 'none' | replaceNewlines: 'span'"
														></span>
													</th>
													<td
														mat-cell
														*matCellDef="let item; let index = index"
														[attr.data-label]="'Employee'"
													>
														<ng-container
															*lowgileScope="item; as: 'item'; let $scope"
														>
															<ng-container
																*lowgileScope="index; as: 'index'; let $scope"
															>
																<span
																	[innerHtml]="_DataTableColumnBlock_cellText_51({ app, screen, $pathSegments, $disabled, item, index }) | escapeHtml: 'none' | replaceNewlines: 'span'"
																></span>
															</ng-container>
														</ng-container>
													</td>
												</ng-container>
												<ng-container
													[lowgile-column]="('employee') + '$$filter'"
												>
													<th mat-header-cell *matHeaderCellDef></th>
												</ng-container>

												<ng-container [lowgile-column]="'category'">
													<th mat-header-cell *matHeaderCellDef>
														<span
															[innerHtml]="'Category' | escapeHtml: 'none' | replaceNewlines: 'span'"
														></span>
													</th>
													<td
														mat-cell
														*matCellDef="let item; let index = index"
														[attr.data-label]="'Category'"
													>
														<ng-container
															*lowgileScope="item; as: 'item'; let $scope"
														>
															<ng-container
																*lowgileScope="index; as: 'index'; let $scope"
															>
																<span
																	[innerHtml]="_DataTableColumnBlock_cellText_43({ app, screen, $pathSegments, $disabled, item, index }) | escapeHtml: 'none' | replaceNewlines: 'span'"
																></span>
															</ng-container>
														</ng-container>
													</td>
												</ng-container>
												<ng-container
													[lowgile-column]="('category') + '$$filter'"
												>
													<th mat-header-cell *matHeaderCellDef></th>
												</ng-container>

												<ng-container [lowgile-column]="'currency'">
													<th mat-header-cell *matHeaderCellDef>
														<span
															[innerHtml]="'Currency' | escapeHtml: 'none' | replaceNewlines: 'span'"
														></span>
													</th>
													<td
														mat-cell
														*matCellDef="let item; let index = index"
														[attr.data-label]="'Currency'"
													>
														<ng-container
															*lowgileScope="item; as: 'item'; let $scope"
														>
															<ng-container
																*lowgileScope="index; as: 'index'; let $scope"
															>
																<span
																	[innerHtml]="_DataTableColumnBlock_cellText_36({ app, screen, $pathSegments, $disabled, item, index }) | escapeHtml: 'none' | replaceNewlines: 'span'"
																></span>
															</ng-container>
														</ng-container>
													</td>
												</ng-container>
												<ng-container
													[lowgile-column]="('currency') + '$$filter'"
												>
													<th mat-header-cell *matHeaderCellDef></th>
												</ng-container>

												<ng-container [lowgile-column]="'vatAmount'">
													<th mat-header-cell *matHeaderCellDef>
														<span
															[innerHtml]="'VAT' | escapeHtml: 'none' | replaceNewlines: 'span'"
														></span>
													</th>
													<td
														mat-cell
														*matCellDef="let item; let index = index"
														[attr.data-label]="'VAT'"
													>
														<ng-container
															*lowgileScope="item; as: 'item'; let $scope"
														>
															<ng-container
																*lowgileScope="index; as: 'index'; let $scope"
															>
																<span
																	[innerHtml]="_DataTableColumnBlock_cellText_11({ app, screen, $pathSegments, $disabled, item, index }) | escapeHtml: 'none' | replaceNewlines: 'span'"
																></span>
															</ng-container>
														</ng-container>
													</td>
												</ng-container>
												<ng-container
													[lowgile-column]="('vatAmount') + '$$filter'"
												>
													<th mat-header-cell *matHeaderCellDef></th>
												</ng-container>

												<ng-container [lowgile-column]="'tipAmount'">
													<th mat-header-cell *matHeaderCellDef>
														<span
															[innerHtml]="'Tip' | escapeHtml: 'none' | replaceNewlines: 'span'"
														></span>
													</th>
													<td
														mat-cell
														*matCellDef="let item; let index = index"
														[attr.data-label]="'Tip'"
													>
														<ng-container
															*lowgileScope="item; as: 'item'; let $scope"
														>
															<ng-container
																*lowgileScope="index; as: 'index'; let $scope"
															>
																<span
																	[innerHtml]="_DataTableColumnBlock_cellText_12({ app, screen, $pathSegments, $disabled, item, index }) | escapeHtml: 'none' | replaceNewlines: 'span'"
																></span>
															</ng-container>
														</ng-container>
													</td>
												</ng-container>
												<ng-container
													[lowgile-column]="('tipAmount') + '$$filter'"
												>
													<th mat-header-cell *matHeaderCellDef></th>
												</ng-container>

												<ng-container [lowgile-column]="'totalAmount'">
													<th mat-header-cell *matHeaderCellDef>
														<span
															[innerHtml]="'Total' | escapeHtml: 'none' | replaceNewlines: 'span'"
														></span>
													</th>
													<td
														mat-cell
														*matCellDef="let item; let index = index"
														[attr.data-label]="'Total'"
													>
														<ng-container
															*lowgileScope="item; as: 'item'; let $scope"
														>
															<ng-container
																*lowgileScope="index; as: 'index'; let $scope"
															>
																<span
																	[innerHtml]="_DataTableColumnBlock_cellText_10({ app, screen, $pathSegments, $disabled, item, index }) | escapeHtml: 'none' | replaceNewlines: 'span'"
																></span>
															</ng-container>
														</ng-container>
													</td>
												</ng-container>
												<ng-container
													[lowgile-column]="('totalAmount') + '$$filter'"
												>
													<th mat-header-cell *matHeaderCellDef></th>
												</ng-container> </lowgile-table
										></ng-container>
									</mat-card-content>
								</mat-card>
							</div>
						</div>
					</ng-template>
				</Llama-MainLayout>
			</div>
		</ng-container>
	</ng-container>
</ng-container>
